// extracted by mini-css-extract-plugin
module.exports = {"container":"e_ar","link":"e_br","imageContainer":"e_cr","author":"e_dr","text":"e_er","buttonIcon":"e_fr"};